const MuiSlider: any = {
  styleOverrides: {
    root: {
      "& .MuiSlider-markLabel": {
        marginTop: "8px",
      },
    },
  },
};

export default MuiSlider;
